type HostEnv = 'production' | 'stage' | 'development' | 'sandbox' | 'isocomp';

const isDeveloper = computed(() => {
  const { relevantCookies } = useWwwStorage();
  const devCookie = relevantCookies.value.find(
    (cookie) => cookie.name === 'x-www-is-internal-developer'
  );
  return devCookie?.value;
});

const getHostEnv = (): HostEnv => {
  const host = useRequestURL().host;

  if (host.includes('localhost') || host.includes('dev.dev.')) {
    return 'development';
  }

  if (host.includes('stage')) {
    return 'stage';
  }

  if (host.includes('sandbox')) {
    return 'sandbox';
  }

  if (host.includes('isocomp')) {
    return 'isocomp';
  }

  return 'production';
};

const useEnvContext = () => {
  const hostEnv = getHostEnv();

  return readonly({
    isDev: computed(() => hostEnv === 'development'),
    isStage: computed(() => hostEnv === 'stage'),
    isProd: computed(() => hostEnv === 'production'),
    isSandbox: computed(() => hostEnv === 'sandbox'),
    isIsocomp: computed(() => hostEnv === 'isocomp'),
    isDeveloper,
  });
};

export default useEnvContext;
